import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

const domain = process.env.REACT_APP_AUTH0_DOMAIN || "dev-aitube.auth0.com";
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID || "your-client-id";

export const Auth0ProviderWithHistory: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      {children}
    </Auth0Provider>
  );
};
